import apiClient from './apiClient';

export interface QueryParams {
  scNoFrom?: string;
  scNoTo?: string;
  scDateFrom?: string;
  scDateTo?: string;
  customerFrom?: string;
  customerTo?: string;
  productFrom?: string;
  productTo?: string;
  apprDateFrom?: string;
  apprDateTo?: string;
  salesCustomerFrom?: string;
  salesCustomerTo?: string;
  contractType?: number;
  contractStatus?: number;
  groupBy?: string;
}

export interface SCDetailRow {
  FC110_01: string;
  FC110_10: string;
  FC110_11: string;
  FC110_12: string;
  FC110_13: string;
  FC110_22: string;
  FC110_25: string;
  FC110_53: string;
  FC110_58: number;
  FC110_59: string;
  FC110_66: string;
  FC110_521: string;
  FC111_02: number;
  FC111_10: string;
  FC111_11: string;
  FC111_12: string;
  FC111_13: string;
  FC111_14: string;
  FC111_15: string;
  FC111_16: string;
  FC111_57: string;
  FC115_03: number;
  FC115_12: string;
  FC115_13: string;
  FC115_14: string;
  FC115_23: string;
  FC115_152: string;
  dept_name: string;
  salesperson_name: string;
  customer_name: string;
}

export interface QueryResponse {
  data: SCDetailRow[];
  count: number;
  message?: string;
}

export const pwc301Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pwc301/query', params);
    return res.data;
  },
  async lookup(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(
        `/api/pwc301/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`
      );
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
